export const ToggleSwitch = ({ item, labelText, callback }) => {
	return (
		<div className="flex-box flex-align-center flex-end">
			<div className="font-size-s m-0 font-color-grey-60 font-weight-normal">
				{labelText}
			</div>

			<label className="switch m-0 ml-2" aria-label={`${item.description || labelText || "notification"} toggle`}>
				<input
					className="switch-checkbox"
					type="checkbox"
					checked={item.checked}
					onChange={callback}
				/>
				<span className="slider round" />
			</label>
		</div>
	);
};
